import React, { FC } from "react";
import { PageHeadingProps } from "../../interfaces/page-heading.interface";
import { motion, useScroll, useTransform } from "framer-motion";
import AnimatedLogo from "./AnimatedLogo";

const PageHeading: FC<PageHeadingProps> = ({
    heading
}) => {
    const { scrollY } = useScroll();
    
    // Parallax effects - more dramatic for the smaller page heading
    const backgroundY = useTransform(scrollY, [0, 500], [0, -100]);
    const backgroundScale = useTransform(scrollY, [0, 500], [1, 1.1]);
    const logoY = useTransform(scrollY, [0, 500], [0, -50]);
    const headingY = useTransform(scrollY, [0, 500], [0, -80]);
    const headingScale = useTransform(scrollY, [0, 500], [1, 0.8]);
    
    // Darkening overlay that gets stronger with scroll
    const scrollOpacity = useTransform(scrollY, [0, 400], [0, 0.4]);
    
    // Logo rotation effects
    const outerRotation = useTransform(scrollY, [0, 500], [0, 12]);
    const innerRotation = useTransform(scrollY, [0, 500], [0, -8]);
    
    return (
        <div className="page-heading">
            {/* Animated background with gradient */}
            <motion.div
                className="page-heading-background"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'var(--brand-gradient)',
                    y: backgroundY,
                    scale: backgroundScale
                }}
            >
                {/* Darkening overlay based on scroll */}
                <motion.div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        opacity: scrollOpacity
                    }}
                />
            </motion.div>

            {/* Logo behind everything */}
            <motion.div
                className="page-heading-logo"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    x: '-50%',
                    y: useTransform(logoY, (value) => `calc(-50% + ${value}px)`),
                    width: '15%',
                    minWidth: '80px',
                    maxWidth: '120px',
                    opacity: 0.3,
                    zIndex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <AnimatedLogo 
                    outerRotation={outerRotation}
                    innerRotation={innerRotation}
                />
            </motion.div>

            {/* Text content */}
            <motion.div
                style={{
                    position: 'relative',
                    zIndex: 2,
                    y: headingY,
                    scale: headingScale
                }}
            >
                <h1 className="fancy-text mt-5">
                    {heading.toUpperCase()}
                </h1>
            </motion.div>
        </div>
    );
};

export default PageHeading;